module.exports = {
    HIGH_SCHOOL: 1,
    MILITARY: 2,
    ON_CAMPUS_VISIT: 3,
};



//////////////////
// WEBPACK FOOTER
// ./src/constants/spartan-user-types.js
// module id = 107
// module chunks = 58